export default __webpack_public_path__ + "static/media/Group15184.61ff1a81.png";